import { FormValues } from "components/medications/create-regional-block/duck";
import { useInitializeOfflineData, useParams, convertDoseToMg } from "duck";
import {
  GetAnestheticProtocolDocument,
  RegionalBlockTypeEnum,
  useCreateAnestheticProtocolRegionalBlockMutation,
  useDeleteAnestheticProtocolRegionalBlocksMutation
} from "requests";

export const useDeleteMedications = () => {
  const { id: anestheticProtocolId } = useParams();
  const [deleteMedications] = useDeleteAnestheticProtocolRegionalBlocksMutation(
    {
      ignoreResults: true
    }
  );
  const { loadProtocols } = useInitializeOfflineData();

  return (ids: number[]) =>
    deleteMedications({
      variables: { input: { ids } },
      refetchQueries: [
        {
          query: GetAnestheticProtocolDocument,
          variables: { _id: +anestheticProtocolId }
        }
      ]
    }).then(loadProtocols);
};

export const useCreateAnestheticProtocolRegionalBlock = () => {
  const { id: anestheticProtocolId } = useParams();
  const [create] = useCreateAnestheticProtocolRegionalBlockMutation({
    ignoreResults: true
  });
  const { loadProtocols, loadMedications } = useInitializeOfflineData();

  return (values: FormValues, medicationType: RegionalBlockTypeEnum) =>
    create({
      variables: {
        input: {
          anestheticProtocol: +anestheticProtocolId,
          type: medicationType,
          concentration: values.concentration,
          doseMax: convertDoseToMg(values.doseMax, values.doseUnit),
          doseMin: convertDoseToMg(values.doseMin, values.doseUnit),
          volumeToBeInfused: values.volumeToBeInfused,
          medication: values.name
        }
      },
      refetchQueries: [
        {
          query: GetAnestheticProtocolDocument,
          variables: { _id: +anestheticProtocolId }
        }
      ]
    }).then(() => {
      loadProtocols();
      loadMedications();
    });
};
